import React from 'react'
import { BaseRouteParams } from 'hocs'
import { useParams } from 'react-router-dom'
import { ConfirmationDialog } from 'uiComponents/popups/confirmationDialog'
import { removeHash } from 'utils/hash'
import {
    useRedeemUnusedDiscountCodesFromCodeMutation,
    useRedeemUnusedDiscountCodesFromUploadsMutation,
} from 'discounts/reduxQuery'
import { showErrorMessage } from 'uiComponents/message'
import { useTranslation } from 'translations'

interface RedeemCodesProps {
    codeUuid: string
    codeType: 'upload' | 'code'
}

export const RedeemCodes: React.FC<RedeemCodesProps> = ({ codeUuid, codeType }) => {
    const { t } = useTranslation()
    const [redeemUploads, { isLoading: isRedeemingUploads }] = useRedeemUnusedDiscountCodesFromUploadsMutation()
    const [redeemCodes, { isLoading: isRedeemingCodes }] = useRedeemUnusedDiscountCodesFromCodeMutation()
    const { accountSlug } = useParams<BaseRouteParams>()
    const isRedeeming = isRedeemingUploads || isRedeemingCodes

    const onConfirm = () => {
        let response: Promise<any> | null = null

        if (codeType === 'upload') {
            response = redeemUploads({
                accountSlug,
                uuid: codeUuid,
            }).unwrap()
        }

        if (codeType === 'code') {
            response = redeemCodes({
                accountSlug,
                uuid: codeUuid,
            }).unwrap()
        }

        if (response) {
            response
                .catch((res: any) => {
                    showErrorMessage(res?.error?.message || t('discounts.codes.redeemError'), 'redeem_error')
                })
                .finally(removeHash)
        }
    }
    return (
        <ConfirmationDialog
            title={t('discounts.codes.redeemTitle')}
            text={<>{t('discounts.codes.redeemText')}</>}
            buttonText={t('discounts.codes.redeemButton')}
            loading={isRedeeming}
            onConfirm={onConfirm}
            onCancel={removeHash}
        />
    )
}
